let config;
if(process.env.NODE_ENV === 'development'){  
	 config = require('./config/dev.config.js');
}else if(process.env.NODE_ENV === 'production'){
	 config = require('./config/pro.config.js');
}
console.log(process.env)
module.exports = config;


// WEBPACK FOOTER //
// ./src/utils/config.js